import type { Settlement } from '../engine/map/settlement';
import { recordConsumed, recordProduced } from '../engine/map/settlement';
import { getGameConfig } from '../config/gameConfig';
import { getBuildingStorage, getEffectiveOutputCap } from '../engine/settlement/utils';

export function runSmelterTick(settlement: Settlement): boolean {
    if (settlement.buildings.smelter.qty <= 0 || settlement.jobs.smelters <= 0) {
        const hadWork = settlement.production.smelter.progress.length > 0;
        settlement.production.smelter.progress = [];
        return hadWork;
    }
    let changed = false;
    const config = getGameConfig();
    const outputCap = getEffectiveOutputCap(settlement, config, 'smelter', 'ironIngots');
    const storage = getBuildingStorage(settlement, 'smelter');
    while (settlement.production.smelter.progress.length < settlement.jobs.smelters) {
        settlement.production.smelter.progress.push(0);
        changed = true;
    }
    while (settlement.production.smelter.progress.length > settlement.jobs.smelters) {
        settlement.production.smelter.progress.pop();
        changed = true;
    }

    const { ticksPerBatch, orePerBatch, charcoalPerBatch, ingotsPerBatch } =
        config.production.smelter;
    for (let i = 0; i < settlement.production.smelter.progress.length; i += 1) {
        if (storage.ironOre < orePerBatch || storage.charcoal < charcoalPerBatch) break;
        if (outputCap <= 0 || outputCap - storage.ironIngots < ingotsPerBatch) break;
        settlement.production.smelter.progress[i] += 1;
        if (settlement.production.smelter.progress[i] >= ticksPerBatch) {
            settlement.production.smelter.progress[i] -= ticksPerBatch;
            storage.ironOre -= orePerBatch;
            storage.charcoal -= charcoalPerBatch;
            storage.ironIngots += ingotsPerBatch;
            recordConsumed(settlement, 'ironOre', orePerBatch);
            recordConsumed(settlement, 'charcoal', charcoalPerBatch);
            recordProduced(settlement, 'ironIngots', ingotsPerBatch);
            changed = true;
        }
    }

    return changed;
}
